import React, { useEffect, useState } from 'react';
import { useTranslations } from 'use-intl';
import { useNavigate, useLocation } from 'react-router-dom';
import { TabItem, TabMenu } from '@/UIlibrary/TabMenu/TabMenu';
import { Typography } from '@/UIlibrary/Typography/Typography';
import DashboardContent from './DashboardContent';

export const TAB_MY_DASHBOARD = 'dashboard';
export const TAB_COMPANY_DASHBOARD = 'companyDashboard';
export type TAB_KEYS = typeof TAB_MY_DASHBOARD | typeof TAB_COMPANY_DASHBOARD;

const TAB_CONFIGS = {
	dashboard: {
		key: 'dashboard' as TAB_KEYS,
		translationKey: 'MyDashboard',
		content: () => <DashboardContent />
	},
	companyDashboard: {
		key: 'companyDashboard' as TAB_KEYS,
		translationKey: 'CompanyDashboard',
		content: () => <DashboardContent />
	}
};

const Dashboard: React.FC = () => {
	const t = useTranslations('Dashboard');
	const [tabs, setTabs] = useState<TabItem[]>([]);
	const [activeTab, setActiveTab] = useState(0);
	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		setTabs(getTabs());
		setActiveTabIndex(tabs);
	}, []);

	const setActiveTabIndex = (newTabs: TabItem[]) => {
		const urlParams = new URLSearchParams(window.location.search);
		if (urlParams.has('startingTab')) {
			const currentTab = urlParams.get('startingTab') as TAB_KEYS;
			const currentTabIndex = newTabs.findIndex(
				(tab) => tab.title === t(TAB_CONFIGS[currentTab].translationKey)
			);
			setActiveTab(currentTabIndex !== -1 ? currentTabIndex : 0);
		} else {
			setActiveTab(0);
		}
	};

	const getTabs = (): TabItem[] => {
		return Object.values(TAB_CONFIGS).map((tabConfig) => ({
			title: t(tabConfig.translationKey),
			content: tabConfig.content(),
			badgeVisible: false
		}));
	};

	const getStartingTab = (index: number) => {
		switch (index) {
			case 0:
				return TAB_MY_DASHBOARD;
			case 1:
				return TAB_COMPANY_DASHBOARD;
			default:
				return TAB_MY_DASHBOARD;
		}
	};

	const handleTabChange = (index: number) => {
		setActiveTab(index);
		const tabKey = Object.keys(TAB_CONFIGS).find(
			(key) => t(TAB_CONFIGS[key as TAB_KEYS].translationKey) === tabs[index].title
		) as TAB_KEYS;

		if (tabKey) {
			const params = new URLSearchParams();
			params.set('startingTab', getStartingTab(index));
			navigate(`${location.pathname}?${params.toString()}`);
		}
	};
	return (
		<main className="p-3 md:p-8">
			<div className="flex flex-col gap-6">
				<Typography type="display">{t('Welcome')}</Typography>
				<TabMenu
					activeTabIndex={activeTab}
					tabs={tabs}
					maxWidth={1500}
					onTabChanged={handleTabChange}
				/>
			</div>
		</main>
	);
};

export default Dashboard;
